import { render, staticRenderFns } from "./ChimelongAsyncRule.vue?vue&type=template&id=1d49c542&scoped=true"
import script from "./ChimelongAsyncRule.vue?vue&type=script&lang=js"
export * from "./ChimelongAsyncRule.vue?vue&type=script&lang=js"
import style0 from "./ChimelongAsyncRule.vue?vue&type=style&index=0&id=1d49c542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49c542",
  null
  
)

export default component.exports